import URL from '../url'
import Request from '../request'

/**
 *
 * @param {*} formData
 */
export const documentUploadPDFService = formData =>
  new Request(URL.API, URL.DOCUMENT_PDF_UPLOAD).post(formData)

export const documentUploadAudioService = formData =>
  new Request(URL.API, URL.DOCUMENT_AUDIO_UPLOAD).post(formData)
